import React from 'react';
import Helmet from 'react-helmet';
import { useStaticQuery, graphql } from 'gatsby';

interface SEOProps {
    description?: string;
    lang?: string;
    meta?: { name: string; content: string }[];
    title: string;
}

function SEO({ description, lang, meta, title }: SEOProps) {
    const { site } = useStaticQuery(
        graphql`
            query {
                site {
                    siteMetadata {
                        title
                        description
                        author
                    }
                }
            }
        `
    );

    const metaDescription = description || site.siteMetadata.description || '';

    return (
        <Helmet
            htmlAttributes={{
                lang: lang || 'en',
            }}
            title={title}
            titleTemplate={`%s - ${site.siteMetadata.title}`}
            meta={[
                {
                    name: `description`,
                    content: metaDescription,
                },
                {
                    property: `og:title`,
                    content: title,
                },
                {
                    property: `og:locale`,
                    content: `en_US`,
                },
                {
                    property: `og:site_name`,
                    content: `Alisha's Art`,
                },
                {
                    property: `og:description`,
                    content: metaDescription,
                },
                {
                    property: `og:type`,
                    content: `website`,
                },
                {
                    name: `twitter:card`,
                    content: `summary`,
                },
                {
                    name: 'twitter:site',
                    content: `@alishasart`,
                },
                {
                    name: `twitter:creator`,
                    content: site.siteMetadata.author,
                },
                {
                    name: `twitter:title`,
                    content: title,
                },
                {
                    name: `twitter:description`,
                    content: metaDescription,
                },
                {
                    name: `fb:app_id`,
                    content: `411460312589215`,
                },
            ].concat(meta || [])}
        />
    );
}

export default SEO;
